<template>
  <div class="single-answer">
    <div
      class="q-privew"
      @copy.prevent
      @contextmenu="rightClickDisable($event)"
      @mouseup="rightClickDisable($event)"
    >
      <div class="q-number" v-if="currentQuestion.questionNo">Q {{ currentQuestion.questionNo }}</div>
      <div class="q-number-Suggestions" v-if="currentQuestion.suggestions">
        Suggestions {{ currentQuestion.suggestions }}
      </div>
      <div
        @copy.prevent
        @contextmenu="rightClickDisable($event)"
        @mouseup="rightClickDisable($event)"
        class="q-type"  :class="{'question-font':!questionFont(currentQuestion)}"
        v-html="currentQuestion.question_text"
      ></div>
      <div class="pyq-tag-section" v-if="showPyqButton" style="margin-top: 10px; white-space: nowrap;">
                <div
                    v-for="(tag, index) in pyqTags"
                    :key="index"
                    class="pyq-card"
                    style="display: inline-block; margin-right: 8px;"
                >
                    <div class="pyq-btn" style="background-color: #039be5; color: white; padding: 6px 16px; border-radius: 4px; border: 1px solid #039be5; min-width: 60px; text-align: center;">
                        {{ tag }}
                    </div>
                </div>
            </div>
    </div>

    <div
      class="ans-part"
      v-if="showAnswerField"
      @copy.prevent
      @contextmenu="rightClickDisable($event)"
      @mouseup="rightClickDisable($event)"
    >
      <div class="que-row">
        <div :class="practiceSessionView ? 'que-col-2 py-2 numtypequesn-margin-11feb' : 'que-col-2 py-2'">
          <v-text-field
            v-model="currentQuestion.correct_answer"
            type="number"
            outlined
            dense
            hide-details="auto"
            @copy.prevent
            @contextmenu="rightClickDisable($event)"
            @mouseup="rightClickDisable($event)"
            :disabled="currentQuestion.disabled || currentQuestion.isAnswerDisabled"
            @keypress="validateField($event)"
            @keyup="disableField($event)"
            ref="correctAnswer"
          ></v-text-field>
        </div>
      </div>
    </div>
    <div class="test-solution">
      <div v-if="isPastTest">
        <!-- ansStatus: {{currentQuestion.ansStatus}} -->
        <div>
          <v-row>
            <v-col cols="5"
              ><label class="ans-text-3may">Your Answer: </label>{{ currentQuestion.yourAnswer }}
              <span v-if="currentQuestion.isBonus">
                ({{ BONUS_MESSAGE }})
              </span>
            </v-col>
            <v-col cols="6"
              ><label class="ans-text-3may">Correct Answer: </label>{{ currentQuestion.correctAnswer }}</v-col
            >
          </v-row>
          <!-- <v-row>
                        <v-col cols="2">Hint:</v-col>
                        <v-col cols="10">
                            <div v-html="currentQuestion.hint"></div>
                        </v-col>
                    </v-row>-->
          <v-row
            v-if="
              currentQuestion.solutionVideos &&
                currentQuestion.solutionVideos.length
            "
            @copy.prevent
            @contextmenu="rightClickDisable($event)"
            @mouseup="rightClickDisable($event)"
          >
            <v-col cols="12">Video Solution:</v-col>
            <v-col
              cols="10"
              v-for="video in currentQuestion.solutionVideos"
              :key="video.id"
            >
              <div>
                <video height="100" width="150" controls>
                  <source :src="video.video_url" />
                </video>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="no-wrap ans-text-3may" cols="3" sm="1">Solution:</v-col>
            <v-col cols="9" sm="11">
              <div
                @copy.prevent
                @contextmenu="rightClickDisable($event)"
                @mouseup="rightClickDisable($event)"
                v-html="currentQuestion.solution"
              ></div>
            </v-col>
          </v-row>
        </div>
      </div>
      <div
        v-if="
          (currentQuestion.solution &&
            currentQuestion.isPreview &&
            currentQuestion.institute_id === null) || this.currentQuestion.isShowSolution
        "
      >
        <h5 class="Solution">Solution:</h5>
        <div
          @copy.prevent
          @contextmenu="rightClickDisable($event)"
          @mouseup="rightClickDisable($event)"
          v-html="currentQuestion.solution"
        ></div>
      </div>
      <div v-else-if="(currentQuestion.solution && currentQuestion.isPreview) || this.currentQuestion.isShowSolution">
        <h5 class="Solution">Solution:</h5>
        <div
          @copy.prevent
          @contextmenu="rightClickDisable($event)"
          @mouseup="rightClickDisable($event)"
          v-html="currentQuestion.solution"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import isMobile from "is-mobile";
import constants from "@/utils/constants.js";

export default {
  name: "IntegerPrivew",
  props: ["currentQuestion", "showAnswerField", "practiceSessionView","isPreview"],

  data() {
    return {};
  },
  mounted() {
    this.renderMath();
    this.focusOnField();
  },
  computed: {
    ...mapGetters("testStore", ["isPastTest"]),
    ...mapState("userStore", ["user", "myInstitute"]),
    showPyqButton() {
      return (
        this.myInstitute?.id === constants.ONLINE_INSTITUTE_ID &&
        this.user?.role_code === 'ST' &&
        this.currentQuestion?.question_tags &&
        this.pyqTags.length > 0
      );
    },
    pyqTags() {
      if (!this.currentQuestion?.question_tags) return [];
      const tags = this.currentQuestion.question_tags.split(',');
      return tags
        .filter(tag => tag.includes('PYQ_'))
        .map(tag => tag.replace('PYQ_', '').trim());
    }
  },
  methods: {
    ...mapActions({
      setDisableSecondaryAction: "testStore/setDisableSecondaryAction",
    }),
    focusOnField() {
      if (!isMobile()) {
        if (this.$refs.correctAnswer) {
          this.$refs.correctAnswer.focus();
        }
      }
    },
    validateField(event) {
      this.allowedOnlyNumber(event);
      if (this.allowedOnlyNumber(event)) {
        this.setDisableSecondaryAction(true);
      }
    },
    disableField(event) {
      // console.log(event);
      if (this.allowedOnlyNumber(event)) {
        this.setDisableSecondaryAction(true);
      }
    },
    rightClickDisable(e) {
      e.preventDefault();
    },
  },
  watch: {
    "currentQuestion.correct_answer": function(newVal) {
      if (newVal > "") {
        this.currentQuestion.isAnswered = true;
      } else {
        this.currentQuestion.isAnswered = false;
      }
      if (this.currentQuestion.isAnswered && !this.isPreview) {
        this.setDisableSecondaryAction(true);
      }
    },
    "currentQuestion.id": function(val) {
      this.focusOnField();
      this.setDisableSecondaryAction(false);
      this.renderMath();
      this.renderMath();
    },
  },
};
</script>	